import config from '../config';

const appConfig = config();
const { v2 } = appConfig.apiVersion;
const { apiPrefix } = appConfig;

export default class PolicyService {
  constructor(client) {
    this.client = client;
  }

  async getPolicies({ companyId }) {
    const response = await this.client.get(
      `${apiPrefix}${v2}/companies/${companyId}/policies`
    );
    return response.data;
  }

  async findAll({
    employeeId,
    employeeStatus,
    companyIds,
    insuranceCompanyId,
    status,
    page,
    size
  }) {
    const response = await this.client.get(`${apiPrefix}${v2}/policies`, {
      params: {
        employeeId,
        employeeStatus,
        companyIds,
        insuranceCompanyId,
        status,
        page,
        size
      }
    });
    return response.data;
  }

  async getGroups({ policyId, employeeId, employeeStatus, page, size }) {
    const response = await this.client.get(
      `${apiPrefix}${v2}/policies/${policyId}/group-companies`,
      {
        params: {
          employeeId,
          employeeStatus,
          page,
          size
        }
      }
    );
    return response.data;
  }
}
